import { API_APP_ID, API_PATHS, buildApiUrl } from "../../config";
import { getAuthorizationHeader } from "../../utils/authToken";
import { createApiClient } from "./createApiClient";

/**
 * CRM games API (launch, etc).
 * Base: {API_BASE_URL}api/v1/games/
 * Requires X-App-Id and Authorization: Bearer <token>.
 */
const gamesClient = createApiClient({
  baseURL: buildApiUrl(API_PATHS.GAMES),
  headers: {
    "X-App-Id": API_APP_ID,
  },
});

gamesClient.interceptors.request.use((config) => {
  const authorization = getAuthorizationHeader();
  if (authorization) {
    config.headers.Authorization = authorization;
  }
  return config;
});

export default gamesClient;
